import { Package, Settings, Store } from "lucide-react";
import type { NavItem, NavSection } from "./navigation";

export const MARKETPLACE_NAV_ITEMS: NavItem[] = [
  {
    to: "/marketplace/listings",
    label: "Listings",
    icon: Store,
    perm: "marketplace.moderate_listings",
    module: "marketplace",
  },
  {
    to: "/marketplace/sales",
    label: "Sales",
    icon: Package,
    perm: "marketplace.read",
    module: "marketplace",
  },
  {
    to: "/marketplace/sellers",
    label: "Sellers",
    icon: Store,
    perm: "marketplace.manage",
    module: "marketplace",
  },
  {
    to: "/marketplace/settings",
    label: "Settings",
    icon: Settings,
    perm: "settings.read",
    module: "marketplace",
  },
];

export const MARKETPLACE_NAV_SECTIONS: NavSection[] = [{ items: MARKETPLACE_NAV_ITEMS }];

export const MARKETPLACE_MODULE_ENTRY: NavItem = {
  to: "/marketplace",
  label: "Marketplace",
  icon: Store,
  module: "marketplace",
  keywords: ["marketplace", "c2c", "seller", "listing", "settlement"],
};
